import { PayoutApiClient } from '@fourthwall/services/dist/PayoutApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShopPayoutQuery = createQueryHook(PayoutApiClient.getShopPayout, {
  queryKey: ['shopPayout'],
})
